<template>

<com-item :name="'records.user.' + type" :has-more="true" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" :title="title[type]">

	<template v-slot:stats>

		<app-user v-for="(item, index) in data" :subtext="subtext(item.applicable)" :item="item" v-bind:key="index">

			<core-progress :percent="item.ratio" />

		</app-user>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size', 'type'],

	components: {
		'com-item': comItem
	},

	data: function() {
	
		return {
			title: {
				most: 'Highest win %',
				least: 'Lowest win %'
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/records/users'][this.type]

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	methods: {

		subtext: function(total) {

			return total + ' play' + ((total !== 1) ? 's' : '')

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsRecordsUsers',
				compareType: this.type
			})
		
		}

	}

}

</script>

<style scoped>

</style>